import { MessageType } from '@doveit/bricks';
import { PerformanceRating } from '../../../providers/api/dtos';

export const configByCr: Record<'cr2' | 'cr3', {
  helperContent: string,
  chartCaption: string,
  message: {
    crDefined: string,
    crUndefined: string,
  },
  serpLink: string
}> = {
  cr2: {
    chartCaption: 'CR2 annuale',
    helperContent: 'Il CR2 è il rapporto tra numero di mandati e numero di valutazioni. Il CR2 medio degli agenti di Dove.it è {AVG_CR}%.',
    message: {
      crDefined: 'Contatta le <u>valutazioni da gestire</u> per aumentare il CR2',
      crUndefined: 'Non hai ancora effettuato valutazioni',
    },
    serpLink: 'prospects/explore?filter=toBeManaged',
  },
  cr3: {
    chartCaption: 'CR3 annuale',
    helperContent: 'Il CR3 è il rapporto tra numero di vendite e numero di mandati. Il CR3 medio degli agenti di Dove.it è {AVG_CR}%.',
    message: {
      crDefined: 'Ribassa il prezzo degli <u>immobili</u> per aumentare il CR3',
      crUndefined: 'Non hai ancora acquisito mandati',
    },
    serpLink: 'properties/explore?filter=active',
  },
};

export const configByCrPerformanceRating: Record<PerformanceRating | 'NOT_DEFINED', {
  variant: MessageType,
  title?: string,
}> = {
  CRITICAL: {
    variant: 'critical',
    title: '**{CR}** molto sotto la media ({CR_PERFORMANCE}%)',
  },
  BELOW_EXPECTATIONS: {
    variant: 'warning',
    title: '**{CR}** sotto la media ({CR_PERFORMANCE}%)',
  },
  NEARLY_ON_TRACK: {
    variant: 'info',
    title: '**{CR}** quasi nella media ({CR_PERFORMANCE}%)',
  },
  ON_TRACK: {
    variant: 'info',
    title: '**{CR}** nella media ({CR_PERFORMANCE}%)',
  },
  ABOVE_EXPECTATIONS: {
    variant: 'success',
    title: '**{CR}** sopra la media ({CR_PERFORMANCE}%)',
  },
  NOT_DEFINED: {
    variant: 'neutral',
    title: '**{CR}** non disponibile',
  },
};
